import axios from 'axios';
import { getPortalBackendBaseUrl } from '../hooks/apiUrlResolver';

const postEarlyAccess = async (data: Record<string, unknown>) => {
  const response = await axios.post(`${getPortalBackendBaseUrl()}/early-access`, data);
  return response;
};

export default postEarlyAccess;
